import { Component, Vue } from 'vue-property-decorator'
import E from 'wangeditor'
import { editMessageTemplate, getTemplateDetail, queryCourseB, queryAutoSendTemplateByCourseId, getFoundationCourse } from '@/api'
import { TagsViewModule } from '@/store/modules/tags-view'
import urlBase from '@/utils/urlBase'

@Component({ name: 'email-template-edit-page' })
export default class EmailTemplateEditPage extends Vue {
  private templateId: any = ''
  private attachment: any = []
  private templateData: any = {}
  private editor: any = null
  private autoSend = false
  private courseCurrentTemplateName = '[无]'
  private courseList: any = []
  private currentCourseId: any = null
  // todo
  // private uploadUrl = 'http://192.168.0.116:10069/upload/email/file'
  private uploadUrl = urlBase.eduBaseUrl + 'upload/email/file'
  private foundationCourse: any = {}
  created () {
    this.templateId = this.$route.query.id
    this.initPageData()
  }

  mounted () {
    this.editor = new E('#editor1')
    this.editor.config.excludeMenus = [
      'emoticon',
      'video',
      'img',
      'bold',
      'italic'
    ]
    this.editor.create() // 创建富文本实例
  }

  private async initPageData () {
    const loading = this.$loading({ fullscreen: true })
    const result: any = await getTemplateDetail({ id: Number(this.templateId) })
    this.templateData = result
    this.attachment = result.attachment
    this.editor.txt.html(this.templateData.detail)
    this.autoSend = result.autoSend
    if (result.autoSendTemplateId) {
      if (result.autoSendTemplateId * 1 === this.templateId * 1) {
        this.autoSend = true
        this.courseCurrentTemplateName = '[当前模板]'
      } else {
        this.courseCurrentTemplateName = `[${result.autoSendTemplateName}-创建时间：${result.autoSendTemplateCreatedAt}]`
      }
    }
    if (result.courseId) {
      const res: any = await queryCourseB({ courseId: result.courseId })
      console.log('res: ', res)
      this.courseList = res.map((item: any) => {
        item.courseName = `${item.name}-[项目类型：${item.typeStr}]-[小搜开课时间：${item.schoolBegins}]`
        return item
      })
      this.currentCourseId = result.courseId
      const res1: any = await getFoundationCourse({ courseId: this.currentCourseId })
      this.foundationCourse = res1
    }
    loading.close()
  }

  private async onSaveClick () {
    const obj = this.courseList.find((item: any) => item.id === this.currentCourseId)
    if (obj && (obj.enable * 1 === 0)) {
      this.$message({ message: '请重新选择项目', type: 'error' })
      return
    }
    const { error }: any = await editMessageTemplate({
      id: Number(this.templateId),
      detail: this.editor.txt.html(),
      subject: this.templateData.subject,
      templateType: this.templateData.templateType,
      autoSend: this.autoSend,
      courseId: this.currentCourseId,
      templateName: this.templateData.templateName,
      attachment: this.attachment.map((item: any) => { return item.id })
    })
    if (!error) {
      if (this.autoSend) {
        this.courseCurrentTemplateName = '[当前模板]'
      }
      this.$message({ message: '操作成功', type: 'success' })
      TagsViewModule.delView(this.$route)
      this.$router.go(-1)
    }
  }

  private handleUploadSuccess (res: any) {
    this.attachment.push(res.data)
  }

  private handleRemove (data: any, list: any) {
    this.attachment = list
  }

  private async getCourseInfo (data: any) {
    console.log('data: ', data)
    if (!data || data === '') { return }
    const res: any = await queryCourseB({ name: data })
    this.courseList = res.map((item: any) => {
      item.courseName = `${item.name}-[项目类型：${item.typeStr}]-[小搜开课时间：${item.schoolBegins}]`
      return item
    })
  }

  private async queryTemplateByCourseId () {
    const loading = this.$loading({ fullscreen: true })
    if (!this.currentCourseId) {
      this.$message({ type: 'warning', message: '项目id异常' })
      loading.close()
      return
    }
    const res: any = await queryAutoSendTemplateByCourseId({ courseId: this.currentCourseId })
    if (res.id) {
      this.courseCurrentTemplateName = `[${res.templateName}-创建时间：${res.createdAt}]`
      this.autoSend = res.id === this.templateId
      if (res.id * 1 === this.templateId * 1) {
        this.courseCurrentTemplateName = '[当前模板]'
      }
    } else {
      this.autoSend = false
      this.courseCurrentTemplateName = '[无]'
    }
    const res1: any = await getFoundationCourse({ courseId: this.currentCourseId })
    this.foundationCourse = res1
    loading.close()
  }
}
